// -*- coding: utf-8 -*-
import React from 'react';
import TextField from '@mui/material/TextField';

export default function SearchInput({ value, onChange, disabled, placeholder = 'Ara (isim, telefon, içerik)', size = 'small', sx }) {
  return (
    <TextField
      size={size}
      fullWidth
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      sx={sx}
    />
  );
}
